<template>
    <div class="flex justify-center items-center flex-shrink-0 px-4">
        <span class="font-bold text-gray-400 text-2xl flex justify-center">
            <logo class="h-8 w-auto inline"/>
        </span>
    </div>
    <nav class="mt-5 flex-1" aria-label="Sidebar">
        <div class="px-2 space-y-1" v-for="item in navigation">
            <div v-if="!item.subNavs"
                :key="item.name" @click="visit(item.href, 'get')"
                class="group flex items-center px-5 py-5 text-sm font-medium rounded-md cursor-pointer"
                :class="[isUrl(item.href) ? 'bg-gray-200 text-gray-900' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 hover:text-gray-900']">
                <component :is="item.icon" :class="[isUrl(item.href) ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 h-6 w-6']" aria-hidden="true" />
                {{ item.name }}
            </div>
            <div v-if="item.subNavs" :key="item.name" :class="[isUrl(item.href) ? 'bg-gray-200 text-gray-900' : 'text-gray-600 dark:text-gray-300', 'group flex items-center px-5 py-5 text-sm font-medium rounded-md']">
                <component :is="item.icon" :class="['text-gray-400', 'mr-3 h-6 w-6']" aria-hidden="true" />
                {{ item.name }}
            </div>
            <div v-if="item.subNavs" class="px-8 space-y-1">
                <div v-for="subitem in item.subNavs"
                    class="group flex items-center px-5 py-5 text-sm font-medium rounded-md cursor-pointer"
                    :key="subitem.name" @click="visit(subitem.href, 'get')"
                    :class="[isUrl(subitem.href) ? 'bg-gray-200 text-gray-900' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 hover:text-gray-900']">
                    <component :is="subitem.icon" :class="[isUrl(subitem.href) ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 h-6 w-6']" aria-hidden="true" />
                    {{ subitem.name }}
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import Logo from '@/Shared/Logo'
import { Link } from '@inertiajs/inertia-vue3'

import {
    CogIcon,
    ChipIcon,
    UsersIcon,
    ChartPieIcon,
    TemplateIcon,
    BriefcaseIcon,
    UserCircleIcon,
    AnnotationIcon,
    ShieldExclamationIcon,
} from '@heroicons/vue/outline'

const navigation = [
    { name: 'Dashboard', href: '/', icon: TemplateIcon },
    { name: 'Workloads', icon: BriefcaseIcon,
        subNavs: [
            { name: 'Customers', href: '/customers', icon: UserCircleIcon },
            { name: 'Requests', href: '/orders', icon: AnnotationIcon },
        ]
    },
    { name: 'Settings', icon: CogIcon,
        subNavs: [
            { name: 'Meta', href: '/settings/meta', icon: ChipIcon },
            { name: 'Categories', href: '/settings/categories', icon: ChartPieIcon },
            { name: 'Users', href: '/settings/users', icon: UsersIcon },
            { name: 'Login Approvals', href: '/settings/login-approvals', icon: ShieldExclamationIcon },
        ]
    },
]

export default {
    components: {
        Link,
        Logo,
    },
    setup() {
        return {
            navigation,
        }
    },
    emits: ['navigating'],
    methods: {
        isUrl(...urls) {
            let currentUrl = this.$page.url
            if (urls[0] === '') {
                return currentUrl === ''
            }
            return urls.filter((url) => {
                let baseUrl = currentUrl.split('?')[0]
                return baseUrl === url
            }).length
        },
        visit(href, method) {
            this.$emit('navigating');
            this.$inertia.visit(href, {method})
        }
    }
}
</script>
